<mat-card class="riege-card riege-release-report">
    <div class="riege-release-report__content">
        <mat-card-content>
            <mat-card-title>{{ data().title }}</mat-card-title>

            <mat-chip-set class="riege-chips" aria-label="Release tags">
                @for (tag of tags(); track tag) {
                    <mat-chip disabled="disabled">{{ tag }}</mat-chip>
                }
            </mat-chip-set>

            @if (text()) {
                <p>{{ text() }}</p>
            }
        </mat-card-content>
        <mat-card-actions>
            <a
                [href]="data().href"
                target="_blank"
                mat-stroked-button
                class="riege-button"
                i18n="@@button-label-read-release-report">
                Read release report
            </a>
        </mat-card-actions>
    </div>

    <img class="riege-release-report__image" [src]="image()" alt="" aria-hidden="true" />
</mat-card>
